<template>
  <div class="row poppins h-100">
    <div class="col-12 h-100">
      <div class="table-wrapper h-100 d-flex flex-column">
        <div class="filter-block">
          <SearchInput :searchChange="searchChange" />
          <div class="d-flex">
            <b-button
              v-if="isCommonAdmin"
              v-b-modal.add-team
              variant="primary"
              size="lg"
              class="ml-3 pl-3 pr-4 d-flex align-items-center"
            >
              <BIconPlus class="mr-2" />
              {{ 'new_team' | i18n }}
            </b-button>
            <AddTeam :get-page="getPage" />
            <b-button
              v-if="CAN_DELETE.includes(auth.role) && isCommonAdmin"
              variant="outline-danger"
              size="lg"
              class="ml-3 pl-4 pr-4 d-flex align-items-center"
              :disabled="!selectedList.length"
              @click="deleteTeams"
            >
              <img :src="deleteIconUrl" class="mr-2" />
              {{ 'remove_team' | i18n }}
            </b-button>
          </div>
        </div>
        <Table
          :update="getPage"
          :columns="columns"
          :rows="rows"
          :filter="filter"
          :updateFilter="updateFilter"
          :loadingInstance="loadingInstance"
          :setLoadingInstance="setLoadingInstance"
          :selectedList="selectedList"
          :setSelectedList="setSelectedList"
          class="overflow-auto pr-1"
          tableName="teamsTable"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { BIconArrowRightShort, BIconPlus, BIconSearch } from 'bootstrap-vue';
import { CAN_DELETE } from '../../../../../../../constants';

import { ReportsMixin, DeleteRowMixin, NotificationMixin, AuthMixin } from '../../../../mixins';
import PageHeader from '../../common/page-header';
import Table from '../../common/table';
import SearchInput from '../../common/search-input';
import DeleteIcon from '../../../../assets/icons/delete.svg';
import DetailsIcon from '../../../../assets/icons/iconsCode/details';

import AddTeam from './add-team';

let inputInterval = null;

export default {
  title: 'Teams',
  components: { PageHeader, BIconPlus, BIconSearch, Table, AddTeam, SearchInput, DetailsIcon },
  mixins: [ReportsMixin, DeleteRowMixin, NotificationMixin, AuthMixin],
  data() {
    return {
      deleteIconUrl: DeleteIcon,
      selectedList: [],
      loadingInstance: null,
      CAN_DELETE: CAN_DELETE,
      filter: {
        page: 1,
        limit: 10,
        totalCount: 0,
        sortBy: '',
        sortOrder: '',
        searchQuery: '',
      },
      columns: [
        {
          field: 'name',
          title: this.$translate('name'),
          key: '2',
          sortBy: '',
          align: 'left',
        },
        {
          field: 'description',
          title: this.$translate('description'),
          key: '3',
          sortBy: '',
          align: 'left',
        },
        {
          field: 'actions',
          title: '',
          key: '6',
          width: 50,
          renderBodyCell: ({ row }) => {
            return (
              <div class="action-block">
                <b-button variant="primary" size="sm" class="p-2 size-12" on-click={() => this.goToTeamDetails(row.id)}>
                  <DetailsIcon />
                </b-button>
              </div>
            );
          },
        },
      ],
      rows: [],
    };
  },
  created() {
    if (this.CAN_DELETE.includes(this.auth.role)) {
      this.columns.unshift({
        field: 'check',
        key: '1',
        type: 'checkbox',
        title: '',
        width: 50,
        align: 'center',
      });
    }
  },
  methods: {
    updateFilter(f) {
      this.filter = {
        ...this.filter,
        ...f,
      };
    },
    setSelectedList(list) {
      this.selectedList = list;
    },
    setLoadingInstance(loadingInstance) {
      this.loadingInstance = loadingInstance;
    },
    searchChange(e) {
      const v = e.target.value;
      this.filter.searchQuery = v;
      if (inputInterval) {
        clearTimeout(inputInterval);
      }
      inputInterval = setTimeout(() => {
        this.getPage();
      }, 500);
    },
    goToTeamDetails(id) {
      this.$router.push({ name: 'team-details', params: { id } });
    },
    async deleteTeams() {
      try {
        await this.deleteSelectedRows(
          {
            message: this.$translate('team_delete_message'),
            rowDisplayValues: this.selectedList.map((r) => r.name),
          },
          async () => {
            const ids = this.selectedList.map((r) => r.id);
            await this.reportsService.deleteTeams({ ids });
            this.rows = this.rows.filter((i) => !ids.includes(i.id));
            this.selectedList = [];
            this.getPage();
          }
        );
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
    startLoading() {
      this.loadingInstance.show();
    },
    stopLoading() {
      this.loadingInstance.close();
    },
    async getPage() {
      try {
        this.startLoading();
        const { page, limit, sortBy, sortOrder, searchQuery } = this.filter;
        const ctx = {
          page,
          limit,
          sortBy,
          sortOrder,
          searchQuery,
        };
        const response = await this.reportsService.getTeams(ctx);
        this.filter.totalCount = response.totalCount;
        this.stopLoading();
        this.rows = response.data;
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .ve-table-body {
  ::v-deep th {
    color: rgb(112, 112, 112) !important;
    background-color: rgb(239, 239, 239) !important;
    border: none !important;
    min-height: 50px;
  }
  ::v-deep td {
    color: rgb(112, 112, 112) !important;
    cursor: pointer;
  }
}

::v-deep .ve-table-cell-selection {
  border: none !important;
}

::v-deep .ve-table-sort {
  top: -4.5px;
}

::v-deep .details-action {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background: rgb(34, 129, 254);
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 28px;
  margin: auto;
}

.statuses-block {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.date-range-block {
  min-width: 350px;
  text-align: center;
  margin-left: 30px;
  display: flex;
  align-items: center;
}

::v-deep .ve-select-selected-span {
  font-weight: 400;
}

.pagination-block {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}

::v-deep .copy-button {
  background: rgb(237, 248, 254);
  border: 2px solid rgb(175, 216, 255);
  border-radius: 4px;
  padding: 2px 13px;
  margin: 0px 5px;
  color: rgb(49, 141, 255);
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  margin-right: 20px;
}

.action-block {
  display: flex;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}

::v-deep .size-12 {
  font-size: 12px;
  line-height: 12px;
}
</style>
